import { 
    CLEAN_EVENT_STATS, GET_NUMBER_OF_DELIVERED_PHOTOS, GET_STATS_BY_EVENT_ID, LOADING_STATS,
    GET_PURCHASES_FOR_HISTORY, LOADING_PURCHASES_HISTORY,
    GET_CONSUMPTIONS_FOR_HISTORY, LOADING_CONSUMPTIONS_HISTORY,
    GET_CREDIT_MOVEMENTS, LOADING_CREDIT_MOVEMENTS, SET_CREDIT_FILTERS,
    GET_NUMBER_OF_INDEXES_FACES, GET_NUMBER_OF_PHOTOS, GET_NUMBER_OF_SELFIES, GET_NUMBER_OF_USERS_ACCESS_BY_CODE, GET_NUMBER_OF_USERS_WITH_MATCH, GET_NUMBER_OF_UNIQUES_SHARES_BY_EVENT, GET_NUMBER_OF_UNIQUES_VIEWS_BY_EVENT, GET_NUMBER_OF_GLOBAL_VIEWS_BY_EVENT, GET_PHOTOS_BY_USER, GET_ORDERS_AMOUNT, GET_NUMBER_OF_ORDERS, GET_NUMBER_OF_PACK_ORDERS, GET_TOTAL_AMOUNT_ORDERS, GET_TOTAL_AMOUNT_PACK_ORDERS, GET_SOLD_PHOTOS, GET_SOLD_PACKS_AMOUNT 
} from "./type";
import StatsService from "../../services/statsService";

export const getStatsByEventId = (eventId) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_STATS,
            payload: true
        });
        const response = await StatsService.getStatsByEventId(eventId);
        dispatch({
            type: GET_STATS_BY_EVENT_ID,
            payload: response.data
        });
        dispatch({
            type: LOADING_STATS,
            payload: false
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfDeliveredPhotos = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfDeliveredPhotos(eventId);
        dispatch({
            type: GET_NUMBER_OF_DELIVERED_PHOTOS,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfIndexedFaces = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfIndexedFaces(eventId);
        dispatch({
            type: GET_NUMBER_OF_INDEXES_FACES,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfPhotos = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfPhotos(eventId);
        dispatch({
            type: GET_NUMBER_OF_PHOTOS,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfSelfies = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfSelfies(eventId);
        dispatch({
            type: GET_NUMBER_OF_SELFIES,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfUsersAccessByCode = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfUsersAccessByCode(eventId);
        dispatch({
            type: GET_NUMBER_OF_USERS_ACCESS_BY_CODE,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfUsersWithMatch = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfUsersWithMatch(eventId);
        dispatch({
            type: GET_NUMBER_OF_USERS_WITH_MATCH,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfUniquesSharesByEvent = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfUniquesSharesByEvent(eventId);
        dispatch({
            type: GET_NUMBER_OF_UNIQUES_SHARES_BY_EVENT,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfUniquesViewsByEvent = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfUniquesViewsByEvent(eventId);
        dispatch({
            type: GET_NUMBER_OF_UNIQUES_VIEWS_BY_EVENT,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getNumberOfGlobalViewsByEvent = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfGlobalViewsByEvent(eventId);
        dispatch({
            type: GET_NUMBER_OF_GLOBAL_VIEWS_BY_EVENT,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getPhotosByUser = (eventId) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_STATS,
            payload: true
        });
        const response = await StatsService.getPhotosByUser(eventId);
        dispatch({
            type: GET_PHOTOS_BY_USER,
            payload: response.data
        });
        dispatch({
            type: LOADING_STATS,
            payload: false
        });
    } catch (error) {
        console.log(error);
        dispatch({
            type: LOADING_STATS,
            payload: false
        });
    }
}

export const getOrdersAmount = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getOrdersAmount(eventId);
        dispatch({
            type: GET_ORDERS_AMOUNT,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    };
};

export const getNumberOfOrders = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfOrders(eventId);
        dispatch({
            type: GET_NUMBER_OF_ORDERS,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    };
};

export const getNumberOfPackOrders = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getNumberOfPackOrders(eventId);
        dispatch({
            type: GET_NUMBER_OF_PACK_ORDERS,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    };
};

export const getTotalAmountOrders = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getTotalAmountOrders(eventId);
        dispatch({
            type: GET_TOTAL_AMOUNT_ORDERS,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    };
};

export const getTotalAmountPackOrders = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getTotalAmountPackOrders(eventId);
        dispatch({
            type: GET_TOTAL_AMOUNT_PACK_ORDERS,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    };
};

export const getSoldPhotos = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getSoldPhotos(eventId);
        dispatch({
            type: GET_SOLD_PHOTOS,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};

export const getSoldPacksAmount = (eventId) => async (dispatch) => {
    try {
        const response = await StatsService.getSoldPacksAmount(eventId);
        dispatch({
            type: GET_SOLD_PACKS_AMOUNT,
            payload: response.data
        });
    } catch (error) {
        console.log(error);
    }
};


export const cleanEventStats = () => async (dispatch) => {
    dispatch({
        type: CLEAN_EVENT_STATS
    });
};

// ========================================
// ACCIÓN UNIFICADA PARA COMPRAS
// ========================================

export const getPurchasesStats = (params = {}) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_PURCHASES_HISTORY,
            payload: true
        });
        
        const response = await StatsService.getCreditPurchasesStats(params);
        
        // Enviar datos crudos al store - el procesamiento se hace en componentes
        dispatch({
            type: GET_PURCHASES_FOR_HISTORY,
            payload: response.data
        });
        
        dispatch({
            type: LOADING_PURCHASES_HISTORY,
            payload: false
        });
    } catch (error) {
        console.error('Error fetching purchases stats:', error);
        dispatch({
            type: LOADING_PURCHASES_HISTORY,
            payload: false
        });
    }
};

// ========================================
// ACCIÓN UNIFICADA PARA CONSUMOS
// ========================================

export const getConsumptionsStats = (params = {}) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_CONSUMPTIONS_HISTORY,
            payload: true
        });
        
        const response = await StatsService.getCreditConsumptionsStats(params);
        
        // Enviar datos crudos al store - el procesamiento se hace en componentes
        dispatch({
            type: GET_CONSUMPTIONS_FOR_HISTORY,
            payload: response.data
        });
        
        dispatch({
            type: LOADING_CONSUMPTIONS_HISTORY,
            payload: false
        });
    } catch (error) {
        console.error('Error fetching consumptions stats:', error);
        dispatch({
            type: LOADING_CONSUMPTIONS_HISTORY,
            payload: false
        });
    }
};

export const getCreditMovements = (params = {}) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_CREDIT_MOVEMENTS,
            payload: true
        });

        const response = await StatsService.getCreditStats(params);

        dispatch({
            type: GET_CREDIT_MOVEMENTS,
            payload: response.data
        });

        dispatch({
            type: LOADING_CREDIT_MOVEMENTS,
            payload: false
        });
    } catch (error) {
        console.error('Error fetching credit movements:', error);
        dispatch({
            type: LOADING_CREDIT_MOVEMENTS,
            payload: false
        });
    }
};

export const setCreditFilters = (filters) => ({
    type: SET_CREDIT_FILTERS,
    payload: filters
});
